import { gql } from '@provision/graphql-client';

const CONVERSATION_TRIAGE_FIELDS = gql`
  fragment ConversationTriageFields on ConversationTriage {
    id
    conversationTriageId
    partnerId
    name
    isDefault
    instructions
    actionConfig
    llmConfig
  }
`;

export const GET_TRIAGE_SETTINGS_PAGE_DATA_QUERY = gql`
  query GetTriageSettingsPageData($partnerId: Int!) {
    getTriageSettingsPageData(partnerId: $partnerId) {
      template {
        tools {
          name
          label
          description
        }
        defaultVisibility
        instructions
        llmConfig
        actionConfig
      }
      currentTriage {
        enabled
        config {
          conversationTriageId
          instructions
          actionConfig
          llmConfig
        }
        configurations {
          conversationTriageId
          name
          isDefault
          instructions
          actionConfig
          llmConfig
          usedByBehaviors {
            behaviorId
            name
          }
        }
        defaultConversationTriageId
      }
    }
  }
`;

export const CREATE_CONVERSATION_TRIAGE = gql`
  mutation CreateConversationTriage($data: ConversationTriageDataInput) {
    createConversationTriage(data: $data) {
      ...ConversationTriageFields
    }
  }
  ${CONVERSATION_TRIAGE_FIELDS}
`;

export const UPDATE_CONVERSATION_TRIAGE = gql`
  mutation UpdateConversationTriage(
    $conditions: [ConditionInput]
    $data: ConversationTriageDataInput
  ) {
    updateConversationTriage(conditions: $conditions, data: $data) {
      ...ConversationTriageFields
    }
  }
  ${CONVERSATION_TRIAGE_FIELDS}
`;

export const SOFT_DELETE_CONVERSATION_TRIAGE = gql`
  mutation SoftDeleteConversationTriage($input: SoftDeleteConversationTriageInput!) {
    softDeleteConversationTriage(input: $input)
  }
`;

export const SET_DEFAULT_CONVERSATION_TRIAGE = gql`
  mutation SetDefaultConversationTriage($input: SetDefaultConversationTriageInput!) {
    setDefaultConversationTriage(input: $input)
  }
`;
